import { WebComponentAPI } from 'ohw-app-container-external-component-host';
import { createContext } from 'react';

const ComponentContextContext = createContext<WebComponentAPI.ComponentContext>(
  {} as WebComponentAPI.ComponentContext
);

export default ComponentContextContext;
